module.exports = __webpack_public_path__ + "static/media/spicyLevel10.b1338fdf.svg";